import { useAddResourceBundle } from './i18n/use-add-resource-bundle';
import { useTranslationCareerSiteAdminShared } from './i18n/use-translations';

/**
 * Calculate the difference in time between a given date and today.
 * Returns a string indicating days, months or years passed.
 */
export const getTimePassed = (dateString: string): string => {
  useAddResourceBundle();
  const { t } = useTranslationCareerSiteAdminShared();
  const givenDate = new Date(dateString);
  const today = new Date();

  givenDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffMs = today.getTime() - givenDate.getTime();
  if (diffMs < 0) {
    return `0 ${t('DAYS')}`;
  }

  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays < 30) {
    return `${diffDays} ${diffDays !== 1 ? t('DAYS') : t('DAY')}`;
  }

  const rawDiffMonths =
    today.getFullYear() * 12 +
    today.getMonth() -
    (givenDate.getFullYear() * 12 + givenDate.getMonth());
  const diffMonths =
    rawDiffMonths === 0 ? Math.ceil(diffDays / 30) : rawDiffMonths;

  if (diffMonths < 12) {
    return `${diffMonths} ${diffMonths !== 1 ? t('MONTHS') : t('MONTH')}`;
  }

  const diffYears = today.getFullYear() - givenDate.getFullYear();
  return `${diffYears} ${diffYears !== 1 ? t('YEARS') : t('YEAR')}`;
};
